import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IEmailAutoTrigger,
  IEmailAutoTriggerState,
} from "./emailAutoTriggerModel";
import {
  createEmailAutoTrigger,
  deleteEmailAutoTrigger,
  duplicateEmailAutoTrigger,
  getAllEmailAutoTriggers,
  getEmailAutoTriggerByID,
  updateEmailAutoTrigger,
} from "./services/emailAutoTrigger.services";

const initialState: IEmailAutoTriggerState = {
  loading: false,
  error: "",
  EmailAutoTriggerID: null,
  EmailAutoTriggerList: [],
  EmailAutoTriggerDetail: {
    TriggerName: "",
    Module: "",
    Operation: "",
    Email_To: "",
    DelayDay: null,
    DelayHour: null,
    DelayTime: null,
    SubjectName: "",
    EmailText: "",
  },
  FilterEmailAutoTrigger: {
    TriggerName: "",
    Module: "",
    Operation: "",
    Email_To: "",
  },
};

const emailAutoTriggerSlice = createSlice({
  name: "emailAutoTrigger",
  initialState,
  reducers: {
    clearEmailAutoTriggerDetails: (state) => {
      state.EmailAutoTriggerDetail = initialState.EmailAutoTriggerDetail;
    },
    setEmailAutoTriggerID: (state, action) => {
      state.EmailAutoTriggerID = action.payload;
    },
    clearEmailAutoTriggerID: (state) => {
      state.EmailAutoTriggerID = initialState.EmailAutoTriggerID;
    },
    setFilterEmailAutoTrigger: (state, action) => {
      state.FilterEmailAutoTrigger = action.payload;
    },
    clearFilterEmailAutoTrigger: (state) => {
      state.FilterEmailAutoTrigger = initialState.FilterEmailAutoTrigger;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEmailAutoTriggers.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllEmailAutoTriggers.fulfilled,
      (state, action: PayloadAction<IEmailAutoTrigger[]>) => {
        state.loading = false;
        state.EmailAutoTriggerList = action.payload || [];
      }
    );
    builder.addCase(getAllEmailAutoTriggers.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EmailAutoTriggerList = [];
    });
    builder.addCase(createEmailAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createEmailAutoTrigger.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(createEmailAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateEmailAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateEmailAutoTrigger.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateEmailAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteEmailAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteEmailAutoTrigger.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteEmailAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getEmailAutoTriggerByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getEmailAutoTriggerByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.EmailAutoTriggerDetail = action.payload;
    });
    builder.addCase(getEmailAutoTriggerByID.rejected, (state, action) => {
      state.loading = false;
      state.EmailAutoTriggerDetail = initialState.EmailAutoTriggerDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(duplicateEmailAutoTrigger.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(duplicateEmailAutoTrigger.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(duplicateEmailAutoTrigger.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearEmailAutoTriggerDetails,
  clearEmailAutoTriggerID,
  setEmailAutoTriggerID,
  setFilterEmailAutoTrigger,
  clearFilterEmailAutoTrigger,
} = emailAutoTriggerSlice.actions;
export default emailAutoTriggerSlice.reducer;
